<template>
  <div>
    <article-autoassign-rules v-if="project"/>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import ArticleAutoassignRules from '@/components/coding-admin/article-autoassign-rules';
  export default {
    name: 'ArticleAssignmentRules',
    components: {'article-autoassign-rules': ArticleAutoassignRules},

    mounted() {
      const projectUid = this.$route.params.project_uid;
    },

    computed: {
      ...mapState({
        user: state => state.user.user.data,
        project: state => state.projects.project.data
      }),
    },
  };
</script>